/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICommisionJunction contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum pageType {
    accountCenter = 'accountCenter',
    accountSignup = 'accountSignup',
    applicationStart = 'applicationStart',
    branchLocator = 'branchLocator',
    cart = 'cart',
    category = 'category',
    conversionConfirmation = 'conversionConfirmation',
    department = 'department',
    homepage = 'homepage',
    information = 'information',
    productDetail = 'productDetail',
    propertyDetail = 'propertyDetail',
    propertyResults = 'propertyResults',
    searchResults = 'searchResults',
    storeLocator = 'storeLocator',
    subCategory = 'subCategory'
}

export interface ICommisionJunctionConfig extends Msdyn365.IModuleConfig {
    isCJEnabled?: boolean;
    cookieName?: string;
    enterpriseId?: string;
    pageType?: pageType;
}

export interface ICommisionJunctionProps<T> extends Msdyn365.IModule<T> {
    config: ICommisionJunctionConfig;
}
